export default "__VITE_ASSET__CYN_hVrd__"